export default "__VITE_ASSET__D$z$ZnsK__"